import { ChecklistItem } from '@app/app/_components/ChecklistItem/ChecklistItem';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { TextButton } from '@app/app/_components/TextButton/TextButton';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { PersonalInsuranceCover } from '@app/domain/model/eshop/personal-accidents/PersonalInsuranceCover';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';

interface Props {
    covers: PersonalInsuranceCover[];
}

export function IncludedCovers({ covers }: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = () => {
        setShowAll(prev => !prev);
    };

    const displayedCovers = showAll ? covers : covers.slice(0, 4);
    const hasMore = covers.length > 4;

    return (
        <>
            {displayedCovers.map(cover => (
                <ChecklistItem key={cover.code}>
                    <div className="flex gap-1">
                        <Paragraph>{`${cover.name}:`}</Paragraph>
                        <Paragraph isBold>{formatEuroValue(cover.sumInsured, tenant)}</Paragraph>
                        <Paragraph>{`(${t('eshop.personalAccidents.forOnePerson')})`}</Paragraph>
                    </div>
                </ChecklistItem>
            ))}
            {hasMore && (
                <TextButton onClick={toggleShowAll} rightAddon={<ArrowRightIcon className="size-4" />} size="small">
                    {showAll ? t('general.showLess') : t('general.showAll')}
                </TextButton>
            )}
        </>
    );
}
